import React from 'react';
import styled from 'styled-components';

const Success: React.FC = () => {
  return <h1>Success!</h1>;
};

export default Success;
